import {get} from './httpApi';

/*显示banner列表*/
export function getBannerList(){
    return get('/banner/noJwt/getPcBannerList',{})
}
/*显示PC广告位列表*/
export function getAdvertisementList(){
    return get('/banner/noJwt/getPcAdvertisementList',{})
}
